import { render, staticRenderFns } from "./OrderStop.vue?vue&type=template&id=c445a2ce&scoped=true"
import script from "./OrderStop.vue?vue&type=script&lang=js"
export * from "./OrderStop.vue?vue&type=script&lang=js"
import style0 from "./OrderStop.vue?vue&type=style&index=0&id=c445a2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c445a2ce",
  null
  
)

export default component.exports